//
//   Copyright (c) 2020-2024, ResMed Inc. All rights reserved.
//

const nextGenExpandDuration = "1.5s";

const nextGenExpandTimingFunction = "ease";

export const nextGenExpandHeightTransition = `height ${nextGenExpandDuration} ${nextGenExpandTimingFunction}`